import React, { useState } from 'react';
import {
  Button,
  useMutation,
  useNotify,
  AutocompleteInput,
  ReferenceInput,
  SimpleForm,
  useRefresh,
} from 'react-admin';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import AssignmentTurnedInRoundedIcon from '@material-ui/icons/AssignmentTurnedInRounded';

import { makeStyles } from '@material-ui/styles';
import { thereWasProblem } from '../../Utils/messages';
import { Theme } from '../../Theme';
import { EmployeeState, Position } from '../../Utils/enums';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(0.5),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
  },
  content: { '& > *': { padding: '0 !important' } },
  buttonSpacing: {
    margin: '0rem 0rem 1rem 0rem;',
  },
}));

const LawyerAssignButton = (props) => {
  const notify = useNotify();
  const classes = useStyles();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [lawyer, setLawyer] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setLawyer('');
    setOpen(false);
  };

  const [handleSubmit, { loading }] = useMutation(
    {
      type: 'create',
      resource: 'loan-applications/assign-lawyer',
      payload: {
        data: { loanApplications: props.selectedIds, lawyer },
      },
    },
    {
      onSuccess: () => {
        handleClose();
        notify('Abogado asignado exitosamente');
        refresh();
      },
      onFailure: (error) => {
        notify(
          `${thereWasProblem}: ${
            (error.body.data ? error.body.data.error : error.body.error) ||
            'Fallo general'
          }`,
          'warning'
        );
      },
    }
  );

  return (
    <div className={classes.root}>
      <Button
        className={classes.buttonSpacing}
        endIcon={<AssignmentTurnedInRoundedIcon />}
        variant='contained'
        label='Asignar abogado Sr'
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='xs'
        fullWidth
      >
        <MuiDialogTitle id='form-dialog-title' disableTypography>
          <Typography variant='h4'>Abogado Sr</Typography>
        </MuiDialogTitle>
        <DialogContent>
          <SimpleForm toolbar={<></>} className={classes.content}>
            <ReferenceInput
              source='lawyer'
              resource='loan-applications'
              reference='employees'
              fullWidth
              variant='outlined'
              filter={{
                position: Position.SrLawyer,
                state: EmployeeState.Active,
              }}
            >
              <AutocompleteInput
                onSelect={(record) => setLawyer(record.id)}
                optionText={(record) =>
                  record &&
                  `${record.code} | ${record.person?.firstName ?? ''} ${
                    record.person?.fatherLastName ?? ''
                  }`
                }
              />
            </ReferenceInput>
          </SimpleForm>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            label='Cancelar'
            onClick={() => handleClose()}
            color='primary'
          />
          <Button
            label='Asignar'
            onClick={handleSubmit}
            color='primary'
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LawyerAssignButton;
